import React from 'react';
import * as PropTypes from 'prop-types';

const Pdf = ({ classNames, fileName }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 32"
      fill="none"
      className={classNames}
    >
      <title>{fileName}</title>
      <path
        d="M0 3C0 1.34315 1.34441 0 3.00127 0C8.73203 0 13.1523 0 18.383 0L24.5106 6.80851V29C24.5106 30.6569 23.1675 32 21.5106 32H3C1.34315 32 0 30.6569 0 29V3Z"
        fill="#7C3AED"
      />
      <path d="M18.3828 6.80851V0L24.5105 6.80851H18.3828Z" fill="#5B21B6" />
      <rect x="8.82422" y="12" width="10.7847" height="1" fill="white" />
      <rect x="8.82422" y="16" width="10.7847" height="1" fill="white" />
      <rect x="8.82422" y="20" width="10.7847" height="1" fill="white" />
      <rect
        x="4.90234"
        y="12"
        width="1.96085"
        height="1"
        rx="0.5"
        fill="white"
      />
      <rect
        x="4.90234"
        y="16"
        width="1.96085"
        height="1"
        rx="0.5"
        fill="white"
      />
      <rect
        x="4.90234"
        y="20"
        width="1.96085"
        height="1"
        rx="0.5"
        fill="white"
      />
    </svg>
  );
};

export default Pdf;

Pdf.propTypes = {
  classNames: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired
};
